import styled from "styled-components";
import { Alert } from "antd";

const StyledAlert = styled(Alert)`
  background-color: #e6f7ff !important;
  border: 1px solid #91d5ff !important;
  border-radius: 10px !important;
`;


export { StyledAlert };
